import { Route } from '@angular/router';
import {
  NoAccessPageComponent,
  noRoleGuard,
  roleGuard,
} from '@lyceo/homi-dashboard/user/feature-main';
import { forcedLoginGuard } from '@lyceo/shared/auth/feature-main';
import { DashboardComponent } from './dashboard/dashboard.component';
import { runInSerialGuard } from '@lyceo/shared/util';

const allowedRoles: string[] = [
  'ROLE_SKOLEO_HOMI_ADMIN',
  'ROLE_SKOLEO_HOMI_HEADCOACH',
  'ROLE_SKOLEO_HOMI_COACH',
];

export const appRoutes: Route[] = [
  {
    path: 'no-access',
    component: NoAccessPageComponent,
    canActivate: [noRoleGuard(['/'], allowedRoles)],
  },
  {
    path: '',
    canActivate: [
      runInSerialGuard([
        forcedLoginGuard(),
        roleGuard(['/no-access'], allowedRoles),
      ]),
    ],
    children: [
      {
        path: '',
        redirectTo: 'plan',
        pathMatch: 'full',
      },
      {
        path: '',
        component: DashboardComponent,
        children: [
          {
            path: 'plan',
            loadChildren: () =>
              import('@lyceo/homi-dashboard/plan/feature-main').then(
                (m) => m.featureMainRoutes,
              ),
          },
        ],
      },
    ],
  },
];
